module.exports = __webpack_public_path__ + "images/894ce203c389edb56cdcaf4fe1aabcb1.png";